var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _ellipse, _ellipse2, _rect6, _rect7, _rect8, _rect9, _path4, _circle2, _rect10, _rect11, _rect12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 91,
    viewBox: "0 0 144 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.9414,
    width: 50,
    height: 70,
    rx: 8,
    transform: "rotate(-15 0 12.9414)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.324,
    cy: 25.79,
    r: 13,
    transform: "rotate(-15 29.324 25.79)",
    fill: "#C8C8C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8302 23.9768C35.4954 24.2096 35.7176 25.0388 35.2579 25.573L28.7647 33.1185C28.2407 33.7275 27.2488 33.5011 27.0408 32.725L24.138 21.8915C23.93 21.1154 24.6759 20.4234 25.4342 20.6888L34.8302 23.9768Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9238,
    y: 52.9238,
    width: 38,
    height: 3,
    rx: 1,
    transform: "rotate(-15 16.9238 52.9238)",
    fill: "#C8C8C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7363,
    y: 59.6855,
    width: 38,
    height: 3,
    rx: 1,
    transform: "rotate(-15 18.7363 59.6855)",
    fill: "#C8C8C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5488,
    y: 66.4453,
    width: 24,
    height: 3,
    rx: 1,
    transform: "rotate(-15 20.5488 66.4453)",
    fill: "#C8C8C8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.1172,
    width: 50,
    height: 70,
    rx: 8,
    transform: "rotate(15 95.1172 0)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.415 18.4508L111.103 18.1932L109.821 22.9768L125.134 23.2344L126.415 18.4508Z",
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.448 36.9874L125.134 23.2344M106.136 36.7298L109.821 22.9768M109.821 22.9768L111.103 18.1932L126.415 18.4508L125.134 23.2344M109.821 22.9768L125.134 23.2344",
    stroke: "#C8C8C8",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.589,
    cy: 35.6202,
    rx: 4.64286,
    ry: 3.25,
    transform: "rotate(15 102.589 35.6202)",
    fill: "#C8C8C8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.901,
    cy: 35.878,
    rx: 4.64286,
    ry: 3.25,
    transform: "rotate(15 117.901 35.878)",
    fill: "#C8C8C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7832,
    y: 43.0879,
    width: 38,
    height: 3,
    rx: 1,
    transform: "rotate(15 89.7832 43.0879)",
    fill: "#C8C8C8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.9727,
    y: 49.8496,
    width: 38,
    height: 3,
    rx: 1,
    transform: "rotate(15 87.9727 49.8496)",
    fill: "#C8C8C8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1602,
    y: 56.6113,
    width: 24,
    height: 3,
    rx: 1,
    transform: "rotate(15 86.1602 56.6113)",
    fill: "#C8C8C8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 21,
    width: 50,
    height: 70,
    rx: 8,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9725 56H49.9112C49.1016 56 48.6398 55.0882 49.1049 54.4256L61.9183 36.1664C62.3165 35.599 63.1572 35.599 63.5554 36.1664L70.4268 45.9582C70.7991 46.4887 71.5698 46.5304 71.9972 46.0432L75.62 41.9132C76.035 41.4401 76.7787 41.4634 77.1633 41.9616L86.7564 54.3889C87.2638 55.0463 86.8029 56 85.9725 56Z",
    fill: "#C8C8C8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 33,
    r: 4,
    fill: "#C8C8C8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 64,
    width: 38,
    height: 3,
    rx: 1,
    fill: "#C8C8C8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 71,
    width: 38,
    height: 3,
    rx: 1,
    fill: "#C8C8C8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 78,
    width: 24,
    height: 3,
    rx: 1,
    fill: "#C8C8C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.353f62a4.svg";
export { ForwardRef as ReactComponent };